import { colors } from "../../styles/colors";


const Divider = ({ color = colors.grey025, type = 'solid' }) => {

    return (
        <div style={{ width: '100%', borderTop: `1px ${type} ${color}` }} />
    )
}

export default Divider;